<template>
  <div class="ht-container ht-container-admin pb-5">
    <div class="box pt-2 pl-2 pr-2">
      <div
        v-for="message in $store.state.messages.all"
        :key="'message-'+message.id"
        class="p-2 row border-bottom">
        <span class="col-9 text-left">
          <strong>{{ message.fromUser.username }}:</strong>
          {{ message.message }}
        </span>
        <span class="col-3 text-muted text-right small">
          4 hours ago
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';

@Component
class Messages extends Vue {

  mounted() {
    this.handleMessages();
  }

  handleMessages() {
    this.$store.dispatch('messages/getAll');
    console.log(this.$store.state.messages[0]);
  }
}
export default Messages;
</script>

<style scoped>

.box {
  display: flex;
  flex-direction: column;
  flex-basis: 70%;
  flex-shrink: 1;
  flex-grow: 1;
  background-color: #fff;
  text-align: center;
}

.box > h4 {
  margin: 1.25rem 0 .5rem;
  font-size: .75rem;
  text-transform: uppercase;
  color: #5c6072;
  font-weight: 400;
  line-height: 1.2;
}

</style>
